export const typeOptions = [
  { label: "اختبار", value: "1" },
  { label: "واجب", value: "2" },
  { label: "اختبار لفيديو", value: "6" },
  { label: " study with agwad", value: "7" },
];

export const difficultyOptions = [
  { label: "notes", value: "1" },
  { label: "Studing and remebering", value: "2" },
  { label: "Hard and challenging", value: "3" },
  { label: "Previous exams", value: "4" },
  { label: "Revision", value: "5" },
];

export const subTypeOptions = [
  { label: "اختبار (من فصل واحد)", value: "1" },
  { label: "  اختبار شامل (من اكتر من فصل)", value: "2" },
  { label: "اختبار من التاجات", value: "3" },
];

export const bookmarkOptions = [
  { label: " اختبار به اسئلة مهمة", value: "1" },
  { label: " اختبار عادي", value: "0" },
];

export const randomOptions = [
  { label: " اختبار به اسئلة مهمة", value: "0" },
  { label: " اسئلة عشوائية من بنك الاسئلة", value: "1" },
];

export const colourStyles = {
  control: (styles) => ({
    ...styles,
    width: "100% !important",
    background: "#f5f5f5",
    color: "#690000",
    borderRadius: "16px",
  }),
  container: (styles) => ({ ...styles, width: "100% !important" }),
  option: (styles) => ({ ...styles, color: "#690000" }),
};
